import { TestResultStatusEnum } from "@/domain/enrollment.enum";

/**
 * Frontend display labels for test result status
 */
export const TestResultStatusDisplay: Record<TestResultStatusEnum, string> = {
  [TestResultStatusEnum.CREATED]: "Created",
  [TestResultStatusEnum.PENDING]: "Pending",
  [TestResultStatusEnum.POSITIVE]: "Positive",
  [TestResultStatusEnum.NEGATIVE]: "Negative",
  [TestResultStatusEnum.SUCCESSFUL]: "Successful",
  [TestResultStatusEnum.MISSED]: "Missed",
  [TestResultStatusEnum.FAILED]: "Failed",
  [TestResultStatusEnum.NONE]: "None",
};

/**
 * Format backend status to user-friendly display label
 * @param status - Backend status
 * @returns Display label
 */
export const formatTestResultStatus = (
  status: string | null | undefined,
): string => {
  if (!status) return "Unknown";

  const upperStatus = status.toUpperCase() as TestResultStatusEnum;
  return TestResultStatusDisplay[upperStatus] || status;
};

/**
 * Parse frontend display status back to backend format
 * @param displayStatus - Display label (e.g., "Active")
 * @returns Backend status (e.g., "ACTIVE")
 */
export const parseTestResultStatus = (displayStatus: string): string => {
  const entry = Object.entries(TestResultStatusDisplay).find(
    ([, display]) => display.toLowerCase() === displayStatus.toLowerCase(),
  );

  return entry ? entry[0] : displayStatus.toUpperCase();
};

/**
 * Get all available test result statuses for filters/dropdowns
 * @returns Array of display statuses
 */
export const getTestResultStatusOptions = (): string[] => {
  return Object.values(TestResultStatusDisplay);
};
